// Finder preview-mode helpers.

const PREVIEW_FLAG = 'finderPreview';

/** Visitor arrived via a `?preview=1` link (persisted for nav). */
export function isPreviewIntent(): boolean {
  if (typeof window === 'undefined') return false;
  const fromUrl = new URLSearchParams(window.location.search).get('preview') === '1';
  try {
    if (fromUrl) {
      window.localStorage.setItem(PREVIEW_FLAG, '1');
      return true;
    }
    return window.localStorage.getItem(PREVIEW_FLAG) === '1';
  } catch {
    // localStorage may throw in privacy modes.
    return fromUrl;
  }
}

/** We've already bounced through login for this preview attempt (loop guard). */
export function hasPreviewAuthAttempt(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('preview_auth') === '1';
}

// Mirror of `config.isPublished` for non-React callers. Defaults false.
let published = false;

/** AppConfigProvider stamps the resolved publish state here. */
export function setPublished(value: boolean): void {
  published = value;
}

export function isPublished(): boolean {
  return published;
}

/** Suppress analytics only while previewing an unpublished finder. */
export function isAnalyticsSuppressed(): boolean {
  return isPreviewIntent() && !isPublished();
}
